var map = {
	"./git-stats.js": "./src/data-sources/git-stats.js",
	"./github-stats.js": "./src/data-sources/github-stats.js",
	"./npm-stats.js": "./src/data-sources/npm-stats.js",
	"./packages.js": "./src/data-sources/packages.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 139;



//////////////////
// WEBPACK FOOTER
// ./src/data-sources nonrecursive .js$
// module id = 139
// module chunks = 0